export default __webpack_public_path__ + "static/InsightFeatureFive-4a21142e8255b729335ce2f72fa6c7b2.webp";